import Key from "./Key";
import PropTypes from "prop-types";

const QwertyPortraitLayout = ({
  className = "",
  appearance = "Light",
  state = "Lowercase Letters",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center p-10xs gap-3 text-center text-6xl text-light-text1 font-text-regular-lowercase ${className}`}
      data-appearance={appearance}
      data-state={state}
    >
      <div className="flex flex-row items-start justify-start gap-1.5">
        <Key style="Lowercase" showKey letter="q" showIcon={false} />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="w"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="e"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="r"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="t"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="y"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="u"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="none"
          keyPadding="0"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="i"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="o"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="p"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
      </div>
      <div className="flex flex-row items-start justify-start gap-1.5">
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="a"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="s"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="d"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="f"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="g"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="h"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="j"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="k"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letter="l"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Lowercase"
          showKey={false}
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="31.5px"
          keyFlex="unset"
          letterTextTransform="lowercase"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
      </div>
      <div className="w-[369px] flex flex-row items-start justify-start gap-[14.3px]">
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="42px"
          keyFlex="unset"
          letter="m"
          letterTextTransform="lowercase"
          showIcon
          iconLeft="calc(50% - 16px)"
        />
        <div className="flex-1 flex flex-row items-start justify-start gap-1.5">
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="z"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="x"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="c"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="v"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="b"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="n"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
          <Key
            style="Lowercase"
            showKey
            keyBorder="unset"
            keyPadding="unset"
            keyWidth="unset"
            keyFlex="1"
            letter="m"
            letterTextTransform="unset"
            showIcon={false}
            iconLeft="calc(50% - 15.75px)"
          />
        </div>
        <Key
          style="Lowercase"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="42px"
          keyFlex="unset"
          letter="m"
          letterTextTransform="lowercase"
          showIcon
          iconLeft="calc(50% - 16px)"
        />
      </div>
    </div>
  );
};

QwertyPortraitLayout.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  appearance: PropTypes.number,
  state: PropTypes.number,
};

export default QwertyPortraitLayout;
